<template>
  <div>
    <v-container class="container px-0 mb-4">
      <v-row
        class="title-row"
        :class="`${
          $vuetify.breakpoint.mdAndDown ? 'flex-column flex-nowrap' : ''
        }`"
      >
        <v-col class="d-flex align-center title-column">
          <!-- <h4 class="font-weight-light">
            {{ $t("heading.hosting.summary.title") }}
          </h4> -->
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end py-0">
          <v-btn
            v-if="adminServerUrl"
            large
            color="primary"
            class="p-2 font-weight-bold ml-auto"
            elevation="0"
            :href="adminServerUrl"
            :target="'_blank'"
          >
            <v-icon size="22" class="white--text">$externallink</v-icon>
            {{ $t("button.fullServerManagement") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="mt-3 px-0">
      <v-row>
        <v-col cols="12">
          <UsageCard />
          <GraphsCard />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ControlPanelSsoMixin from "../../mixins/ControlPanelSsoMixin";
import UsageCard from "./UsageCard.vue";
import GraphsCard from "./GraphsCard.vue";

export default {
  components: {
    UsageCard,
    GraphsCard,
  },
  mixins: [ControlPanelSsoMixin],
  props: {},
  watch: {},
  created() {},
  data: function () {
    return {};
  },
  computed: {
    isAppSingleServer() {
      return !!this.$store.state.home.app.single_server?.active;
    },
    isUserSingleServerAdmin() {
      return (
        this.isAppSingleServer && !!this.$store.state.home.user?.is_ss_default
      );
    },
    adminServerUrl() {
      if (!this.isUserSingleServerAdmin) {
        return null;
      }
      return this.$store.state.home.admin?.app_url + "/server";
    },
  },
  methods: {},
};
</script>
